import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface PrimaryButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}
export function PrimaryButton({
  href,
  children,
  className = ''
}: PrimaryButtonProps) {
  const isCheckout = href.includes('impultienda.ar/checkout');
  function handleClick() {
    if (!isCheckout || typeof window === 'undefined') return;
    const pixel = window as Window & {
      fbq?: (event: string, name: string, data?: Record<string, unknown>) => void;
    };
    pixel.fbq?.('track', 'InitiateCheckout', {
      content_name: 'ESL Teacher Ready Complete 6-in-1 System',
      value: 27,
      currency: 'USD'
    });
  }
  return <a href={href} target={isCheckout ? '_blank' : undefined} rel={isCheckout ? 'noopener noreferrer' : undefined} onClick={handleClick} className={`inline-flex min-h-[58px] items-center justify-center gap-3 rounded-xl border border-emerald-400 bg-emerald-500 px-7 py-4 text-center text-sm font-extrabold tracking-wide text-white shadow-cta transition duration-200 hover:-translate-y-0.5 hover:bg-emerald-600 focus:outline-none focus-visible:ring-4 focus-visible:ring-emerald-400/40 ${className}`} data-id="element-213">
      {children}
      <ArrowRightIcon size={18} strokeWidth={3} aria-hidden="true" data-id="element-214" />
    </a>;
}